<template>
  <el-table
    :data="data"
    style="width: 100%"
    size="medium"
    header-row-class-name="supervision-table-header"
    row-class-name="common-table-row"
    class="is-print-hide common-table"
    border
  >
    <el-table-column label="药品通用名" min-width="200" prop="drugName"></el-table-column>
    <el-table-column label="药品规格" min-width="140" prop="drugSpec"></el-table-column>
    <el-table-column label="包装单位" min-width="150" prop="drugUnit"></el-table-column>
    <el-table-column label="药品条形码" min-width="200" prop="barCode"></el-table-column>
    <el-table-column label="生产厂家" min-width="250" prop="enterprise"></el-table-column>
    <el-table-column label="批准文字" min-width="200" prop="approvalNumber"></el-table-column>
    <el-table-column label="药品类型" min-width="150" prop="secondaryClassify">
      <template #default="{ row: { secondaryClassify } }">
        {{ secondaryClassify | secondaryClassify }}
      </template>
    </el-table-column>
    <el-table-column prop="storeContactsName" label="状态">
      <template #default="{ row: { drugStatus } }">
        <span :class="{ red: drugStatus == 0, green: drugStatus == 1 }">
          {{ drugStatus | adaptStatus }}
        </span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import dayjs from 'dayjs';

export default {
  name: 'supervisionList',
  props: {
    pageNo: {
      default: 1
    },
    pageSize: {
      default: 10
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    adaptStatus(val) {
      const statusMap = { 1: '启用', 0: '停用' };
      return statusMap[val];
    },
    secondaryClassify(val) {
      const statusMap = { 4: '含麻', 3: '其他特殊药品' };
      return statusMap[val];
    }
  }
};
</script>

<style lang="scss" scoped>
.drug-item {
  position: relative;
  padding: 5px 0;

  .drug-title {
    font-weight: 500;
  }

  &:before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: #efefef;
  }

  &:last-child {
    &:before {
      display: none;
    }
  }
}

.red {
  color: #eb3c36;
}

.green {
  color: #1e8dff;
}

.yellow {
  color: #ebb436;
}
</style>
